module.exports = __webpack_public_path__ + "fonts/Satoshi-MediumItalic.fe9881d.woff2";